import { render } from "./contentManagement.vue?vue&type=template&id=309746bc&scoped=true"
import script from "./contentManagement.vue?vue&type=script&lang=js"
export * from "./contentManagement.vue?vue&type=script&lang=js"

import "./contentManagement.vue?vue&type=style&index=0&id=309746bc&scoped=true&lang=css"

import exportComponent from "E:\\1402\\Back\\API_Core\\ApiCore\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309746bc"]])

export default __exports__